export default "__VITE_ASSET__CLVd_S0O__"